import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TokenSession } from '../../../core/models/users.interface';
import { AuthService, LoginPayload } from '../../../core/services/auth/auth';
import { Router } from '@angular/router';
import { catchError, switchMap } from 'rxjs';
import { LayoutService } from '../../../core/services/layout/layout';
import { ProfileService } from '../../../core/services/profile/profile';
import { DecodedToken } from '../../../core/models/auth.interface';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-login',
  imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormField, MatLabel, MatInput],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login implements OnInit {
  @ViewChild('googleButton', { static: false }) googleButton!: ElementRef;
  private formBuilder = inject(FormBuilder);
  userSession: TokenSession | null = null;
  errorMsg: string | null = null;
  constructor(
    private authService: AuthService,
    private router: Router,
    private layoutService: LayoutService,
    private profileService: ProfileService,
  ) {}

  ngOnInit(): void {
    this.authService.errorMsg$.subscribe((msg) => (this.errorMsg = msg));
    const token = localStorage.getItem('token');
    if (token) {
      this.router.navigate(['home']);
    }
  }

  loginForm = this.formBuilder.group({
    username: ['', [Validators.required]],
    password: ['', Validators.required],
  });

      ngAfterViewInit(): void {
        this.authService.initializeGoogleSignIn().then(() => {
            if (this.googleButton) {
                this.authService.renderGoogleButton(
                    this.googleButton.nativeElement
                )
            }
        })
    }

  onSubmit() {
    if (this.loginForm.status === 'VALID') {
      this.authService
        .login(this.loginForm.value as LoginPayload)
        .pipe(
          catchError((error) => {
            this.authService.setError('El usuario o la contraseña no se encontraron');
            return [];
          }),
          switchMap((response) => {
            if (response) {
              localStorage.setItem('token', JSON.stringify(response));
              this.authService.setToken(response);
              const decodedToken: DecodedToken = jwtDecode(response.access);
              return this.profileService.getOneProfile(String(decodedToken.user_id));
            }
            return [];
          }),
          switchMap((profile) => {
            if (profile) {
              this.profileService.setUserProfile(profile);
              this.authService.setError(null);
              this.router.navigate(['home']);
              this.layoutService.genMenuLinks(profile);
            }
            return [];
          }),
        )
        .subscribe();
    }
  }

  ngOnDestroy() {
    this.layoutService.setShowMenu(true);
  }
}
